/**
 * PostHog wins when it has a value (including `false`). If it doesn't,
 * use the backend `featureAllowance`. A variant string counts as on;
 * missing in both is off.
 */
export const resolveFeatureFlag = (sdkValue: boolean | undefined, backendValue: boolean | string | undefined) =>
  sdkValue ?? Boolean(backendValue);

/**
 * Picks the experiment variant: PostHog string wins; if PostHog has no
 * value, use the backend `featureAllowance` string. Returns `undefined`
 * when neither has a variant.
 */
export const resolveFeatureFlagVariant = (
  sdkValue: string | boolean | undefined,
  backendValue: boolean | string | undefined
) => {
  if (typeof sdkValue === 'string') {
    return sdkValue;
  }

  if (sdkValue !== undefined) {
    return undefined;
  }

  if (typeof backendValue === 'string' && backendValue !== '') {
    return backendValue;
  }

  return undefined;
};
